import styled from "styled-components";
import theme from "../../shared/theme";

export const Container = styled.p`
  color: red;
  font-size: 11px;
  padding-top: 5px;
  margin: 0;
  height: 17px;
  font-weight: bold;
`;
